import s from './TrendsChart.module.css'

type Props = {
  trends: string
}

const TrendsChart = ({ trends }: Props) => {
  const trendsArray = (trends ?? '').split(',').map(Number)
  const BAR_HEIGHT_FACTOR = 10
  const BAR_WIDTH = 4
  const BARS_GAP = 4

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={s.trendsChart}
      height="30"
      width="102"
    >
      {trendsArray.map((value, index) => (
        <rect
          key={`${value}-${index}`}
          x={index * (BAR_WIDTH + BARS_GAP)}
          y={-24}
          width={BAR_WIDTH}
          rx={1}
          height={Math.ceil(value * BAR_HEIGHT_FACTOR)}
          className={s.trendBar}
        />
      ))}
    </svg>
  )
}

export default TrendsChart
